export default __webpack_public_path__ + "static/media/quote-2.0f520309.svg";